import { render, staticRenderFns } from "./SMSCampaignList.vue?vue&type=template&id=f89bf26e&"
import script from "./SMSCampaignList.vue?vue&type=script&lang=js&"
export * from "./SMSCampaignList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports